<dropdown-panel
  title="Climate"
  [collapsedContent]="collapsed"
  [needToScrollBottomAfterExpand]="true"
  [initiallyExpanded]="true"
>
  <div class="wrap expanded">
    <div class="control-status control-status--reauth" *ngIf="controlAvailability === 'needs_reauth'">
      <span>Can't reach your home. Sign in again to control it.</span>
      <button class="control-status__cta" (click)="goToSignIn()">Sign in</button>
    </div>
    <div class="control-status control-status--reconnecting" *ngIf="controlAvailability === 'reconnecting'">
      <ion-spinner name="dots"></ion-spinner>
      <span>Reconnecting to your home…</span>
    </div>
    <auto-schedule-nudge></auto-schedule-nudge>
    <div class="active-schedule-chip" *ngIf="scheduleSplitOn">
      <ion-icon name="calendar-outline"></ion-icon>
      <span>{{ activeSchedule === 'weekend' ? 'Weekend' : 'Weekday' }} schedule active</span>
    </div>
    <div class="thermostats-container" [class.controls-dimmed]="controlAvailability !== 'ready'">
      <ng-container *ngIf="!isSynchroMode">
        <ng-container *ngFor="let device of hvacDevices">
          <div class="item" [ngClass]="{ 'item-disabled': isTemperatureControlDisable(device) }">
            <thermometer-widget
              [label]="device.deviceName"
              [value]="device.currentTemp"
              [setToValue]="device.setToTemp"
              class="item-card"
              [disabled]="!isEnabled(device)"
              [expanded]="true"
              [unavailable]="device.isUnavailable"
            ></thermometer-widget>
            <div class="item-controls">
              <div
                class="arrow"
                (click)="canDecreaseTemp(device) && decreaseTemp(device)"
                [ngClass]="{ 'arrow-disabled': !canDecreaseTemp(device) }"
              ></div>
              <div
                class="arrow arrow-top"
                (click)="canIncreaseTemp(device) && increaseTemp(device)"
                [ngClass]="{ 'arrow-disabled': !canIncreaseTemp(device) }"
              ></div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="isSynchroMode">
        <div class="item" [ngClass]="{ 'item-disabled': isTemperatureControlDisable() }">
          <thermometer-widget
            label="All"
            [value]="currentTempSync"
            [setToValue]="setToTempSync"
            class="item-card"
            [disabled]="!isEnabled()"
            [expanded]="true"
            [unavailable]="isUnavailableSync"
          ></thermometer-widget>
          <div class="item-controls">
            <div
              class="arrow"
              (click)="canDecreaseTemp() && decreaseTemp()"
              [ngClass]="{ 'arrow-disabled': !canDecreaseTemp() }"
            ></div>
            <div
              class="arrow arrow-top"
              (click)="canIncreaseTemp() && increaseTemp()"
              [ngClass]="{ 'arrow-disabled': !canIncreaseTemp() }"
            ></div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="mode-segment" [class.controls-dimmed]="controlAvailability !== 'ready' || isHvacUnavailable">
      <ion-segment [(ngModel)]="selectedMode" (ionChange)="onModeChange($event)" [disabled]="isHvacUnavailable">
        <ion-segment-button *ngFor="let mode of displayModes" [value]="mode" [disabled]="isHvacUnavailable">
          <ion-icon *ngIf="mode === 'cool'" name="snow-outline"></ion-icon>
          <ion-icon *ngIf="mode === 'heat'" name="flame-outline"></ion-icon>
          <ion-icon *ngIf="mode === 'heat_cool'" name="sync-outline"></ion-icon>
          <ion-icon *ngIf="mode === 'off'" name="power-outline"></ion-icon>
          <ion-label>{{ getModeLabel(mode) }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </div>
</dropdown-panel>

<ng-template #collapsed>
  <div class="wrap">
    <div class="active-schedule-chip" *ngIf="scheduleSplitOn">
      <ion-icon name="calendar-outline"></ion-icon>
      <span>{{ activeSchedule === 'weekend' ? 'Weekend' : 'Weekday' }}</span>
    </div>
    <div class="thermostats-container">
      <ng-container *ngIf="!isSynchroMode">
        <div class="collapsed-item" *ngFor="let device of hvacDevices">
          <thermometer-widget
            [label]="device.deviceName"
            [value]="device.currentTemp"
            [disabled]="!isEnabled(device)"
            [unavailable]="device.isUnavailable"
          ></thermometer-widget>
          <div class="mode-indicator">
            <ion-icon *ngIf="device.currentMode === 'cool'" name="snow-outline"></ion-icon>
            <ion-icon *ngIf="device.currentMode === 'heat'" name="flame-outline"></ion-icon>
            <ion-icon *ngIf="device.currentMode === 'heat_cool'" name="sync-outline"></ion-icon>
            <span class="mode-text">
              <ng-container *ngIf="device.isUnavailable">
                Unavailable
              </ng-container>
              <ng-container *ngIf="!device.isUnavailable">
                <ng-container *ngIf="device.currentMode === 'heat' && device.hvacAction?.includes('heating')">
                  Heating to {{ device.setToTemp ? device.setToTemp + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="device.currentMode === 'cool' && device.hvacAction?.includes('cooling')">
                  Cooling to {{ device.setToTemp ? device.setToTemp + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="device.currentMode === 'heat' && !device.hvacAction?.includes('heating')">
                  Heat{{ device.setToTemp ? ' | ' + device.setToTemp + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="device.currentMode === 'cool' && !device.hvacAction?.includes('cooling')">
                  Cool{{ device.setToTemp ? ' | ' + device.setToTemp + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="device.currentMode === 'heat_cool'">
                  Auto{{ device.setToTemp ? ' | ' + device.setToTemp + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="device.currentMode === 'off'">
                  OFF
                </ng-container>
              </ng-container>
            </span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isSynchroMode">
        <div class="collapsed-item">
          <thermometer-widget
            label="All"
            [value]="currentTempSync"
            [disabled]="!isEnabled()"
            [unavailable]="isUnavailableSync"
          ></thermometer-widget>
          <div class="mode-indicator">
            <ion-icon *ngIf="currentModeSync === 'cool'" name="snow-outline"></ion-icon>
            <ion-icon *ngIf="currentModeSync === 'heat'" name="flame-outline"></ion-icon>
            <ion-icon *ngIf="currentModeSync === 'heat_cool'" name="sync-outline"></ion-icon>
            <span class="mode-text">
              <ng-container *ngIf="isUnavailableSync">
                Unavailable
              </ng-container>
              <ng-container *ngIf="!isUnavailableSync">
                <ng-container *ngIf="currentModeSync === 'heat' && hvacActionSync?.includes('heating')">
                  Heating to {{ setToTempSync ? setToTempSync + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="currentModeSync === 'cool' && hvacActionSync?.includes('cooling')">
                  Cooling to {{ setToTempSync ? setToTempSync + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="currentModeSync === 'heat' && !hvacActionSync?.includes('heating')">
                  Heat{{ setToTempSync ? ' | ' + setToTempSync + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="currentModeSync === 'cool' && !hvacActionSync?.includes('cooling')">
                  Cool{{ setToTempSync ? ' | ' + setToTempSync + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="currentModeSync === 'heat_cool'">
                  Auto{{ setToTempSync ? ' | ' + setToTempSync + '°' : '' }}
                </ng-container>
                <ng-container *ngIf="currentModeSync === 'off'">
                  OFF
                </ng-container>
              </ng-container>
            </span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
